import {
	Carousel,
	CarouselContent,
	CarouselItem,
	CarouselNext,
	CarouselPrevious,
} from "@/components/ui/carousel";
import { useEffect, useState } from "react";
import ProductCard from "./product-card";
import { DSS_URL } from "@/lib/config";
import useGlobal from "@/hooks/useGlobal";
import { useMediaQuery } from "react-responsive";
import { Skeleton } from "@/components/ui/skeleton";
import { useNavigate } from "react-router-dom";

const formatProductIds = (productIds: string[]): string => {
	const result = productIds.map((id) => id.replace("PLID", "")).join(",");
	return result;
};

const
SectionProducts = ({
	title,
	keyword,
	banner,
	previewItems,
}: {
	title: string;
	keyword: string;
	banner?: string;
	previewItems?: string[];
}) => {
	const [sections, setSections] = useState<any>([]);
	const [isLoading, setLoading] = useState<boolean>(false);

	const isMobile = useMediaQuery({ maxWidth: 768 });
	const { openInNewTab } = useGlobal();

	// batch-products/72866625,92639732
	const fetchProducts = async () => {
		setLoading(true);
		await fetch(
			previewItems
				? `${DSS_URL}/batch-products/${formatProductIds(previewItems)}`
				: `${DSS_URL}/products?qsearch=${keyword}`
		)
			.then((res) => res.json())
			.then((data) => {

				setSections(previewItems ? { products: data } : data);
				setLoading(false);

			});
	};

	useEffect(() => {
		fetchProducts();
	}, []);

	const navigate = useNavigate();

	// if (sections?.products && sections.products.length == 0) return;

	return (
		<div className="relative max-w-full">
			{isLoading && (
				<Carousel
					opts={{
						align: "start",
					}}
					className="max-w-full py-1 mb-2 sm:mb-2"
				>
					<CarouselContent className="ml-0 md:-ml-4">
						<>
							{[1, 2, 3, 4].map((e) => (
								<CarouselItem
									key={e}
									className="pl-0 sm:pl-4 basis-1/2 sm:basis-1/4 flex items-center select-none"
								>
									<div
										// key={`loader-${index}`}
										className="max-w-64 w-full cursor-not-allowed overflow-hidden rounded-md border  border-input bg-background bg-white p-2 text-sm font-medium shadow-sm transition-colors  focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
									>
										<div className="relative mb-2">
											<Skeleton className="bg-gray-300 h-24 w-full rounded-sm" />
											<Skeleton className="bg-gray-300 absolute left-2 top-2 h-8 w-8 rounded-sm" />
											<Skeleton className="bg-gray-300 absolute left-2 top-12 h-8 w-8 rounded-sm" />
										</div>
										<div className="space-y-2">
											<div className="mb-2 flex items-center justify-between">
												<Skeleton className="bg-gray-300 h-6 w-1/3 " />
												<Skeleton className="bg-gray-300 h-6 w-1/3" />
											</div>
											<Skeleton className="bg-gray-300 h-4 w-full" />
											<Skeleton className="bg-gray-300 h-3 w-full" />
											<Skeleton className="bg-gray-300 h-3 w-full" />
											<div>
												<Skeleton className="bg-gray-300 flex h-48 w-full flex-col gap-2 px-2 py-8">
													<div className="mb-2 flex items-center justify-between">
														<Skeleton className="bg-gray-300 h-4 w-1/3 " />
														<Skeleton className="bg-gray-300 h-4 w-1/3" />
													</div>
													<Skeleton className="bg-gray-300 h-8 w-full rounded-sm" />
													<Skeleton className="bg-gray-300 h-8 w-full rounded-sm" />
													<Skeleton className="bg-gray-300 mt-4 h-4 w-full" />
													<Skeleton className="bg-gray-300 h-4 w-full" />
													<Skeleton className="bg-gray-300 h-4 w-full" />
												</Skeleton>
											</div>
										</div>
									</div>
								</CarouselItem>
							))}
						</>
					</CarouselContent>
					<CarouselPrevious />
					<CarouselNext />
				</Carousel>
			)}
			{sections?.products && sections.products.length > 0 && (
				<>
					{banner && (
						<div
							className="sm:hidden my-2 shadow-md"
							onClick={() =>
								(window.location.href = `/search/${keyword}`)
							}
						>
							<img  src={banner} />
						</div>
					)}
					<div className="py-1 mb-2 sm:mb-2 max-w-full">
						<div className="w-full px-2 sm:px-0 flex justify-between text-sm sm:text-xl items-center my-1">
							<span className=" font-bold my-2">{title}</span>
							<span
								onClick={() => navigate(`/search/${keyword}`)}
								className="border border-solid border-gray-500 text-sm sm:text-sm rounded-sm p-1 px-4 cursor-pointer hover:bg-black hover:text-white"
							>
								View More
							</span>
						</div>
						<Carousel
							opts={{
								align: "start",
							}}
							className="max-w-full"
						>
							<CarouselContent className="ml-0 md:-ml-4">
								{!isLoading &&
									sections.products
										.slice(-6)
										.map((product, key) => (
											<CarouselItem
												key={key}
												className="pl-0 sm:pl-4 basis-1/2 sm:basis-1/4 flex items-center select-none"
											>
												<ProductCard
													openInNewTab={
														isMobile
															? false
															: openInNewTab
													}
													sku={product.sku}
													title={product.title}
													rating={product.rating}
													reviews={product.reviews}
													image={product.image}
													original={product.price.original}
													currency={
														product.price.currency
													}
													selling_price={
														product.price.selling
													}
													listing_price={
														product.price.was
													}
													surcharge={product.price.surcharge}
													markup={
														product.price.markup
													}
													delivery_days={
														product.delivery_days
													}
													next_delivery_date={
														product.next_delivery_date
													}
													is_add_to_cart_available={
														product.is_add_to_cart_available
													}
													stock_available={
														product.stock_availability
													}
													badges={product.badges}
													quantity={product.quantity}
													variants={product.variants}
												/>
											</CarouselItem>
										))}
							</CarouselContent>
							<CarouselPrevious />
							<CarouselNext />
						</Carousel>
					</div>
				</>
			)}
		</div>
	);
};

export default SectionProducts;
